import React from "react";
import useFirestore from "../hooks/useFirestore";
import "./ImageGrid.css";
import { collection } from "@firebase/firestore";
import { projectFirestoreDB } from "../firebase/config";
import { Box, Image } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const ImageGrid = () => {
  const collectionRef = collection(projectFirestoreDB, "memeImages");
  const { docs } = useFirestore(collectionRef);

  return (
    <div className="img-grid">
      {docs &&
        docs.map((doc) => (
          <Link to={"gallery/" + doc.id} key={doc.id}>
            <Box
              maxW="2xl"
              mx="auto"
              py="5"
              //borderWidth="1px"
              //borderRadius="lg"
              overflow="hidden"
              key={doc.id}
            >
              <Image src={doc.url} alt={doc.title} width="100%"></Image>
              <Box p="4" borderWidth="1px" display="flex">
                {doc.title}
              </Box>
            </Box>
          </Link>
        ))}
    </div>
  );
};

export default ImageGrid;
